import React, { useEffect, useState } from 'react';

import TableBody from "./table-body";
import Notify from "../../../../components/notify";
import Loader from "../../../../components/loader";
import {
  getAllFloatInvoiceRequestLogAPI
} from '../../../../services/api';
import NavBar from '../../../../components/Navbar';

const LogList = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openNotify, setOpenNotify] = useState(false);
  const [page, setPage] = useState(0);
  const [totalRowCount, setTotalRowCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    getAllLogs(rowsPerPage, page);
  }, []);

  const getAllLogs = async (currentRowPerPage, currentPage) => {
    try {
      const response = await getAllFloatInvoiceRequestLogAPI({
        limit: currentRowPerPage,
        page: currentPage
      });
      setLogs(response?.logs || []);
      setTotalRowCount(response?.count || 0);
      setLoading(false);
    } catch (err) {
      setErrors(err);
      setOpenNotify(true);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllLogs(rowsPerPage, newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = event.target.value;
    const newPage = 0;
    setPage(newPage);
    setRowsPerPage(newRowsPerPage);
    getAllLogs(newRowsPerPage, newPage);
  };

  return (
    <>
      <NavBar />
      <TableBody
        logs={logs}
        rowsPerPage={rowsPerPage}
        page={page}
        handleChangePage={handleChangePage}
        totalRowCount={totalRowCount}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
      />
      <Loader loading={loading} />
      <Notify
        open={openNotify}
        onClose={() => setOpenNotify(false)}
        errors={errors}
      />
    </>
  );
};

export default LogList;